import { OptionPaymentMethodDto, PaymentMethodFareTypeDto } from "@/dtos";
import { PaymentMethodType } from "@/helpers/types";

const paymentMethodsTypes = [
    { value: PaymentMethodType.DNI, label: 'Cédula', total_passengers: 0, total_balance: '0', fare_types: [] as PaymentMethodFareTypeDto[] },
    { value: PaymentMethodType.CLOSE_LOOP_CARD, label: 'Tarjeta Close Loop', total_passengers: 0, total_balance: '0', fare_types: [] as PaymentMethodFareTypeDto[] },
    { value: PaymentMethodType.CARD_OPEN_LOOP, label: 'Tarjeta Open Loop', total_passengers: 0, total_balance: '0', fare_types: [] as PaymentMethodFareTypeDto[] },
    { value: PaymentMethodType.CARD_BANK, label: 'Tarjeta Bancaria', total_passengers: 0, total_balance: '0', fare_types: [] as PaymentMethodFareTypeDto[] },
    { value: PaymentMethodType.QR, label: 'QR', total_passengers: 0, total_balance: '0', fare_types: [] as PaymentMethodFareTypeDto[] },
] as OptionPaymentMethodDto[];

export const getPaymentMethodTypeOptions = (): OptionPaymentMethodDto[] => {
    return paymentMethodsTypes;
}

export const getPaymentMethodTypeOption = (value?: number): OptionPaymentMethodDto => {
    return paymentMethodsTypes.find((x) => x.value == value) ?? paymentMethodsTypes[0];
}

export const getPaymentMethodTypeLabel = (value: number): string => {
    return paymentMethodsTypes.find((x) => x.value == value)?.label ?? paymentMethodsTypes[0].label;
}